import classnames from 'classnames';
import React from 'react';
import { Translate, withLocalize } from 'react-localize-redux';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import RozbalitIcon from '../../img/icons/BBiconsRozbalit';
import { newsActions } from '../../store/newsStore';
import { popupActions } from '../../store/popupStore';
import { isNullOrUndefined } from '../../store/storeFunctions';
import PopupFilledHeader from '../layoutItems/popupFilledHeader';
import NewsContent from './newsContent';

import "./news.css";

class NewsPopup extends React.Component {
    state = { showButton: false }

    constructor(props) {
        super(props);
        this.scrollbar = React.createRef();
    }

    componentDidMount() {
        const curr = this.scrollbar.current;
        this.setState({ showButton: curr && curr.offsetHeight < curr.scrollHeight });
    }

    render() {
        if (isNullOrUndefined(this.props.item)) {
            this.props.hidePopup();
            return null;
        }

        let n = this.props.item;

        return (
            <div>
                <div key={`${'news'}-${n.newsId}`} className="bb-news-widget" style={{ margin: 'unset' }}>
                    <PopupFilledHeader title={this.props.translate('News.News')} />
                    <div id="container">
                        <PerfectScrollbar containerRef={(el) => { this.scrollbar.current = el; }}
                            className='news-popup-scroll' style={{ width: '100%' }}>
                            <div className="bb-news-widget-headline">{n.header}</div>
                            <div className="bb-news-widget-date-annotation">
                                <div className="bb-news-widget-date small" style={{ paddingTop: '0.1em' }}>{n.validFromFormated}</div>
                                <div className='news-annotations' style={{ paddingLeft: '0.5em' }}>
                                    {typeof n.annotation === 'string' && n.annotation.length > 0 && n.annotation.split(';').map(a =>
                                        <span key={a.trim()} className='news-annotation'>{a.trim()}</span>
                                    )}
                                </div>
                            </div>
                            <NewsContent text={n.text} />
                            {this.renderFooter()}
                        </PerfectScrollbar>
                        {this.renderToBottomButton()}
                    </div>
                </div>
            </div>
        );
    }

    renderToBottomButton = () => {
        return (
            this.state.showButton && <div id="buttonContainer">
                <div onClick={() => this.scrollBottom()} className="to-bottom-button to-top-button">
                    <RozbalitIcon />
                </div>
            </div>
        )
    }

    scrollBottom = () => {
        const curr = this.scrollbar.current;
        if (curr) {
            curr.scrollTop = curr.scrollHeight;
        }
    }

    renderFooter = () => (
        <div className="bb-news-widget-footer bb-news-widget-date-box">
            <button type="button" className={classnames('bb-button small gradient-1-gray', { 'is-square': localStorage.locales_button_style === 'square' })} onClick={() => this.props.close(false)}>
                <Translate id='News.RemindMeLater' />
            </button>
            <button type="button" className={classnames('bb-button small is-primary gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })} onClick={() => this.props.close(true)}>
                <Translate id='News.IAcknowledge' />
            </button>
            <button type="button" className={classnames('bb-button small is-primary gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })} onClick={() => this.props.setAllAsRead()}>
                <Translate id='Common.Dismiss' />
            </button>
        </div>
    )
}

export default withLocalize(connect(
    state => state.news,
    dispatch => bindActionCreators({ ...newsActions, ...popupActions }, dispatch)
)(NewsPopup));
